import { useCallback, useReducer } from "react";
import { RequestActionMeta, RequestReducer, RequestState } from "./types";
import { reducer } from "./reducer";
import { error, inProgress, reset, success } from "./actions";
import { getInitialState } from "./utils";

export const useRequestState = <T>(initialState?: Partial<RequestState<T>>) => {
  const [state, dispatch] = useReducer<RequestReducer<T>>(
    reducer,
    getInitialState(initialState),
  );

  const setInProgress = useCallback((meta?: RequestActionMeta) => {
    dispatch(inProgress(meta));
  }, []);

  const setSuccess = useCallback((payload: T, meta?: RequestActionMeta) => {
    dispatch(success({ data: payload }, meta));
  }, []);

  const setError = useCallback((payload: unknown, meta?: RequestActionMeta) => {
    dispatch(error({ error: payload }, meta));
  }, []);

  const resetState = useCallback((initialState?: Partial<RequestState<T>>) => {
    dispatch(reset(initialState));
  }, []);

  return {
    ...state,
    setInProgress,
    setSuccess,
    setError,
    resetState,
  };
};
